module.exports = new __parcel__URL__("lightbulb-orbit-darkmode.1b2c96a6.svg").toString();